import { render, staticRenderFns } from "./CommunicationNotes.vue?vue&type=template&id=42ce8aa2&scoped=true&"
import script from "./CommunicationNotes.vue?vue&type=script&lang=js&"
export * from "./CommunicationNotes.vue?vue&type=script&lang=js&"
import style0 from "./CommunicationNotes.vue?vue&type=style&index=0&id=42ce8aa2&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42ce8aa2",
  null
  
)

export default component.exports